<template>
  <div>
    <headerimg></headerimg>
    <div class="success-conter">
      <div>
        <img style="width: 4.74rem; margin-top: 0.78rem;" src="../../assets/images/mpesa/fail@2x.png" alt="">
      </div>
      <p class="test-1">Session Expired</p>
      <div>
        <p class="test-2">Your checkout request has expired.</p>
      </div>

    </div>
    <div class="btn" v-if="url && !urlstatus">
      <button @click="gotourl">Okay</button>
    </div>

    <emailtext></emailtext>
  </div>
</template>

<script>
  import {encryption} from "../../utils/requestUtils";

  export default{
    data() {
      return{
        url:'',
        urlstatus:false,
        Params:''
      }
    },
    mounted() {
      this.getParams()
      this.getUserInfo()
    },
    methods:{
      getParams() {

        this.Params = this.$route.query

      },
      gotourl(){
        window.location.href=this.url
      },
      getUserInfo() {
        this.axios.post('/api/order/paymentStatus', {
          requestParam: encryption({
            merchantId: this.Params.merchantId,
            merchantOrderId: this.Params.merchantOrderId
          })
        }).then(res => {
            this.url = res.data.data.callbackUrl
            if(this.url.replace(0,5)!=='http'){
              this.urlstatus = true
            }
        })
      },
    }
  }
</script>

<style lang="scss">
  .success-conter{
    width: 6.54rem;

    margin: 0 auto;
    background: #FFFFFF;
    border-radius: 0.32rem;
    margin-top: 0.54rem;
    padding-bottom: 0.7rem;
    .test-1{
      font-size: 0.4rem;
      font-family: PingFang-SC-Heavy, PingFang-SC;
      font-weight: 800;
      color: #FF6601;
      margin-top: 0.48rem;
    }
    .test-2{
      font-size: 0.28rem;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
      color: #151515;
    }


  }
  .btn{
    button{
      border: none;
      width: 6.54rem;
      height: 1.08rem;

background:  #191932;
      border-radius: 0.16rem;
      font-size: 0.3rem;
      font-family: PingFang-SC-Heavy, PingFang-SC;
      font-weight: 800;
      color: #FFFFFF;
      margin-top: 0.32rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/mpesa/fail.vue